import React, { useEffect, useState } from "react";
import styles from "./leave-request-list-view.module.css";
import CustomTable from "../../../../common/custom-table/custom-table";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../../../../constants/common";
import StatusChip from "../../../../components/status-chip/status-chip";
import moment from "moment";
import CustomButton from "../../../../common/custom-button/custom-button";

const LeaveRequestListView = ({ onViewDetails, leaveList, totalCount }) => {
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const columns = [
    {
      title: "Teacher Name",
      dataIndex: "teacher_name",
      key: "teacher_name",
      sorter: (a, b) => a?.teacher_name - b?.teacher_name,
      render: (value) => value || "-",
    },
    {
      title: "Department",
      dataIndex: "department",
      key: "department",
      sorter: (a, b) => a?.department - b?.department,
      render: (value) => value || "-",
    },
    {
      title: "Leave Type",
      dataIndex: "leave_type",
      key: "leave_type",
      sorter: (a, b) => a?.leave_type - b?.leave_type,
      render: (value) => value || "-",
    },
    {
      title: "Start Date",
      dataIndex: "start_date",
      key: "start_date",
      sorter: (a, b) =>
        dayjs(a?.start_date, DATE_FORMAT.DD_SLASH_MM_SLASH_YYYY).valueOf() -
        dayjs(b?.start_date, DATE_FORMAT.DD_SLASH_MM_SLASH_YYYY).valueOf(),
      render: (value) => moment(value).format("DD/MMM/YYYY") || "-",
    },
    {
      title: "End Date",
      dataIndex: "end_date",
      key: "end_date",
      sorter: (a, b) =>
        dayjs(a?.end_date, DATE_FORMAT.DD_SLASH_MM_SLASH_YYYY).valueOf() -
        dayjs(b?.end_date, DATE_FORMAT.DD_SLASH_MM_SLASH_YYYY).valueOf(),
      render: (value) => moment(value).format("DD/MMM/YYYY") || "-",
    },
    {
      title: "Leave Duration",
      dataIndex: "leave_duration",
      key: "leave_duration",
      sorter: (a, b) => a?.leave_duration - b?.leave_duration,
      render: (value) => value + " days" || "-",
    },
    {
      title: "Applied On",
      dataIndex: "applied_on",
      key: "applied_on",
      sorter: (a, b) =>
        dayjs(a?.applied_on, DATE_FORMAT.DD_SLASH_MM_SLASH_YYYY).valueOf() -
        dayjs(b?.applied_on, DATE_FORMAT.DD_SLASH_MM_SLASH_YYYY).valueOf(),
      render: (value) => moment(value).format("DD/MMM/YYYY") || "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a?.status - b?.status,
      render: (value, record) =>
        value === "Pending" ? (
          <StatusChip status="Action Required" />
        ) : (
          <StatusChip status={value} />
        ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <CustomButton
          title="View Details"
          onClick={() => onViewDetails(record)}
        />
      ),
    },
  ];

  useEffect(() => {
    setPageNo(1);
  }, []);

  const handleChangePage = (page, pageSize) => {
    setPageNo(page);
    setPageSize(pageSize);
  };

  return (
    <CustomTable
      columns={columns}
      dataSource={leaveList}
      loading={loading}
      headerColor="#667085"
      headerBackgroundColor="#F9FAFB"
      total={totalCount}
      pageSize={pageSize}
      currentPage={pageNo}
      handlePageChange={handleChangePage}
    />
  );
};

export default LeaveRequestListView;
